import React, { useState, useEffect } from 'react';
import Menu from '../../Components/UserComponents/Menu';
import styled from 'styled-components';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { photoColumns, phoneColumns } from '../../data/photoSource';
import { Link } from 'react-router-dom';
import { doc, getDoc, collection, onSnapshot, deleteDoc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useNavigate, useParams } from 'react-router-dom';
import ModalComponent from '../../Components/ModalComponent';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import Tooltip from '@mui/material/Tooltip';

import Upload from '../../Components/UserComponents/Upload/Upload';

function List({ title, isMobile }) {
  const [data, setData] = useState([]);
  const [photoData, setPhotoData] = useState([]);
  const { userId, photoId } = useParams();
  const [open, setOpen] = useState(false);
  const [pageSize, setPageSize] = useState(5);
  let navigate = useNavigate();

  useEffect(() => {
    const unsub = onSnapshot(
      collection(db, 'users', userId, 'photos'),
      (snapShot) => {
        let list = [];
        snapShot.docs.forEach((doc) => {
          list.push({ id: doc.id, ...doc.data() });
        });
        setData(list);
      },
      (error) => {
        console.log(error);
      }
    );

    return () => {
      unsub();
    };
  }, [userId]);

  useEffect(() => {
    photoId && getSinglePhoto();
    // eslint-disable-next-line
  }, []);

  const getSinglePhoto = async () => {
    const docRef = doc(db, 'users', userId, 'photos', photoId);
    const snapshot = await getDoc(docRef);
    if (snapshot.exists()) {
      setPhotoData({ ...snapshot.data() });
    }
  };

  const handleOpen = (item) => {
    setOpen(true);
    setPhotoData(item);
  };

  const handleDelete = async (id) => {
    try {
      const docRef = doc(db, 'users', userId);
      const docSnap = await getDoc(docRef);
      const minusSpace = docSnap.data().space + Number(photoData.size);
      const redPhoto = docSnap.data().photos_nr - 1;

      setOpen(false);
      await deleteDoc(doc(db, 'users', userId, 'photos', id));
      await deleteDoc(doc(db, 'photos', id));
      await updateDoc(doc(db, 'users', userId), {
        photos_nr: redPhoto,
        space: Number(minusSpace),
      });
      await deleteDoc(doc(db, 'users', userId, 'albums', photoData.album, 'photos', id));

      setPhotoData(data.filter((item) => item.id !== id));
    } catch (error) {
      console.log(error);
    }
  };

  const actionColumn = [
    {
      field: 'action',
      headerName: 'Action',
      flex: 1,
      align: 'center',
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <div className="viewButton" onClick={() => navigate(params.row.id)}>
              <Tooltip title="View">
                <RemoveRedEyeIcon />
              </Tooltip>
            </div>

            <div className="updateButton" onClick={() => navigate(`update/${params.row.id}`)}>
              <Tooltip title="Edit">
                <EditIcon />
              </Tooltip>
            </div>
            <div className="deleteButton" onClick={() => handleOpen(params.row)}>
              <Tooltip title="Delete">
                <DeleteIcon />
              </Tooltip>
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <ListStyled>
      <Menu title={title} isMobile={isMobile} />
      <div className="list-container">
        <div className="datatable">
          <div className="datatable-title">
            <Upload />
            <Link to="new" className="link">
              <Tooltip title="Add New Photo">
                <Fab color="primary" aria-label="add" sx={{ backgroundColor: '#7199ff' }}>
                  <AddIcon sx={{ color: 'fff' }} />
                </Fab>
              </Tooltip>
            </Link>
          </div>

          <DataGrid
            className="datagrid"
            autoHeight
            rows={data}
            columns={isMobile ? phoneColumns.concat(actionColumn) : photoColumns.concat(actionColumn)}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[5, 10, 20]}
            pagination
            rowHeight={150}
            sx={{
              border: 0,
              p: 1,
              minWidth: 300,
            }}
            components={{ Toolbar: GridToolbar }}
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
              },
            }}
          />

          {open && <ModalComponent open={open} setOpen={setOpen} handleDelete={handleDelete} {...photoData} />}
        </div>
      </div>
    </ListStyled>
  );
}

const ListStyled = styled.div`
  display: flex;
  width: 100%;
  padding-top: 4rem;
  min-height: 100vh;
  .list-container {
    flex: 6;
    .datatable {
      padding: 20px 10px;
      .datatable-title {
        width: 100%;
        font-size: 14px;
        color: var(--accent-blue);
        margin-bottom: 30px;
        display: flex;
        align-items: center;
        justify-content: right;
        padding-right: 3rem;
        padding-top: 0.5rem;
        @media screen and (max-width: 600px) {
          justify-content: center;
          padding-right: 0rem;
        }
        label {
          display: flex;
          align-items: center;
          gap: 10px;

          .icon {
            cursor: pointer;
          }
        }

        .link {
          text-decoration: none;
          font-size: 16px;
          font-weight: 400;

          padding: 0 10px;

          cursor: pointer;
          .icon {
            font-size: 46px;
          }
        }
      }

      .cellWithImg {
        display: flex;
        align-items: center;

        .cellImg {
          width: 320px;
          height: 320px;

          object-fit: cover;
          margin-right: 20px;
        }
      }

      .cellWithStatus {
        padding: 5px;
        border-radius: 5px;

        &.online {
          color: blueviolet;
          background-color: rgba(0, 128, 0, 0.151);
        }
        &.offline {
          color: red;
          background-color: rgba(189, 189, 3, 0.103);
        }
      }

      .cellAction {
        display: flex;
        align-items: center;
        gap: 15px;

        .viewButton {
          color: #7199ff;
          cursor: pointer;
        }
        .updateButton {
          color: lightcoral;
          cursor: pointer;
        }
        .deleteButton {
          color: crimson;

          cursor: pointer;
        }
      }
    }
  }
`;

export default List;
